import { PrintingStatus, PrintingStatusEnum } from '@lib/models/printing'

export const PrinterError = {
  DISCONNECTED: 'disconnected',
  OPEN_DECK: 'open_deck',
  NO_PAPER: 'no_paper',
  LOW_PAPER: 'low_paper'
} as const

export type PrinterErrorType = (typeof PrinterError)[keyof typeof PrinterError]

/**
 * Every error the printer reports, in a fixed display order. Empty means the printer is OK.
 * `status = ERROR` and `sensorError` share the same message, so they collapse in one error.
 */
export const getPrinterErrors = (status: PrintingStatus): PrinterErrorType[] => {
  const errors: PrinterErrorType[] = []
  if (status.status === PrintingStatusEnum.ERROR || status.sensorError)
    errors.push(PrinterError.DISCONNECTED)
  if (status.openDeckError) errors.push(PrinterError.OPEN_DECK)
  if (status.finishedPaperError) errors.push(PrinterError.NO_PAPER)
  if (status.nearFinishedPaperWarning) errors.push(PrinterError.LOW_PAPER)
  return errors
}

// Reported and shown on the inoperative screen, but they do not take the kiosk out of service by
// themselves: the ticket still prints.
const NON_BLOCKING_PRINTER_ERRORS: PrinterErrorType[] = [PrinterError.LOW_PAPER]

/** Whether any of the errors takes the kiosk out of service (low paper alone does not). */
export const hasBlockingPrinterError = (errors: PrinterErrorType[]): boolean =>
  errors.some((error) => !NON_BLOCKING_PRINTER_ERRORS.includes(error))
